export const DOC_MODAL = {
  dialogPaper: "document-modal-flex-root",
  dialogContent: "document-modal-flex-content",
  form: "document-modal-form",
  formFields: "document-modal-form-fields",
  itemsGrow: "document-modal-items-grow",
  itemsPanel: "document-items-panel",
  itemsToolbar: "document-items-panel-toolbar",
  tableGrow: "document-items-table-grow",
};
